import { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { withResizeDetector } from 'react-resize-detector';
import Steve from '@gluenetworks/steve_core';
/* Services */
import DashboardService from '../../../../services/dashboard-service';
/* Components */
import WidgetHeader from '../widget-header/WidgetHeader';
import WidgetHeaderButton from '../widget-header/widget-header-button/WidgetHeaderButton';
import Loader from '../../../common/loader/Loader';
import LicensingContent from './LicensingContent';

const steve = Steve.getInstance();

const LicensingWidget = ({
    showWidgetInfo,
    onRemove,
    onClone,
    isEditAllowed,
    height,
    width,
    data,
    openSolutionsInNewTab,
    isMobileDevice
}) => {
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [licensingData, setLicensingData] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const customClass = useMemo(() => width <= 295 ? 'licensing-width-xs' : '', [width]);

    // eslint-disable-next-line no-restricted-globals
    const url = useMemo(() => steve.router.buildUrl(location.origin, {
        app: 'GameConsole',
        s: 'Settings',
        sln: 'Settings',
        sr: 'Organization/Licensing'
    }), []);
    
    useEffect(() => {
        const licensingAddOn = DashboardService.getLicenseStateForLicensingWidget();

        const onFeedDataUpdated = (data) => {
            setLicensingData(data);
        };

        const loadLicensingFeed = async () => {
            try {
                setIsLoadingData(true);

                licensingAddOn.on('Data', onFeedDataUpdated);

                setLicensingData({ ...licensingAddOn.licenseData });
            } catch (err) {
                setErrorMessage(err.errorMsg);
            }
            finally {
                setIsLoadingData(false);
            }
        };

        loadLicensingFeed();
        return () => {
            licensingAddOn.removeListener('Data', onFeedDataUpdated);
        };
    }, []);

    const openInNewWindow = () => {
        const location = openSolutionsInNewTab ? '_blank' : '_self';

        window.open(url, location);
    };

    return (
        <div className={`licensing-card glu-content ${customClass}`}>
            {isLoadingData && <Loader />}
            <WidgetHeader
              isEditAllowed={isEditAllowed}
              title={data.title}
              height={height}
              width={width}
              showWidgetInfo={showWidgetInfo(data)}
              onRemove={onRemove(data)}
              onClone={onClone(data)}
            >
                <WidgetHeaderButton
                  showButton={!isEditAllowed && !isMobileDevice}
                  iconName='exit-from-the-app'
                  onClick={openInNewWindow}
                  hoverTooltip={'Open in a New Tab'}
                />
            </WidgetHeader>
            <div className="glu-content__body">
                <LicensingContent
                    licensingData={licensingData}
                    errorMessage={errorMessage}
                    isEditAllowed={isEditAllowed}
                />
            </div>
        </div>
    );
};

LicensingWidget.propTypes = {
    data: PropTypes.objectOf(PropTypes.any).isRequired,
    isEditAllowed: PropTypes.bool,
    onRemove: PropTypes.func,
    onUpdate: PropTypes.func,
    showWidgetInfo: PropTypes.func,
    onClone: PropTypes.func
};

LicensingWidget.defaultProps = {
    isEditAllowed: false,
    onRemove: undefined,
    onUpdate: undefined,
    showWidgetInfo: undefined,
    onClone: undefined
};

export default withResizeDetector(LicensingWidget);
